module.exports = __webpack_public_path__ + "img/VPC.d5ed724.png";